import styled, { keyframes, css } from 'styled-components'
import { InputWithLabel, SelectWithLabel } from 'Components/Form'
import { BREAK_POINT_LG } from '@CSSVars/variables'
import {
  PRIMARY_NORMAL_COLOR,
  PRIMARY_SECONDARY_COLOR,
  GREY_LIGHTER_COLOR,
  GREY_DARK_COLOR,
  BUTTON_HOVER,
  CLICKABLE_COLOR,
  SELECTED_ITEM_BG_COLOR,
  TEXT_GREY,
  TEXT_GREY_DARK,
  OUTLINE_COLOR,
} from '@CSSVars/colors'

export const _CalculatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    justify-content: start;
    gap: 0;
  }
`

export const _Title = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 16px 0 8px 0;
  display: flex;
  flex-direction: row;
  .tooltipTrigger {
    height: 14px;
    width: 14px;
    font-size: 10px;
    margin-left: 4px;
  }
`

export const _AdditionalExpenses = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    gap: 0;
  }
`

export const _ResultRow = styled.div`
  display: flex;
  flex:direction: row;
  justify-content: start;
  gap: 16px;
  width: 100%;
  margin-bottom: 12px;
   @media screen and (max-width: ${BREAK_POINT_LG}) {
  justify-content: space-between;
  gap: 12px;

}

`
export const _ItemBoxCol = styled.div`
  position: relative;
  button {
    width: 100%;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
  }
`

export const _PurchasePriceDownPayment = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  ${_ItemBoxCol} {
    width: 50%;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    gap: 0;
    ${_ItemBoxCol} {
      width: 100%;
    }
  }
`

export const _InterestAmortizationFrequency = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    gap: 0;
  }
`

export const _InterestAmortizationDownpayment = styled(
  _InterestAmortizationFrequency,
)`
  width: 100%;
  > div:last-child {
    width: 50%;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    > div:last-child {
      width: 100%;
    }
  }
`

export const _InterestAmortization = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    justify-content: space-between;
  }
`

export const _SelectWithLabel = styled(SelectWithLabel)`
  position: relative;
  margin-bottom: 24px;
  select {
    height: 44px;
    border: 1px solid ${OUTLINE_COLOR} !important;
    border-radius: 10px !important;
    background-color: white !important;
  }
  label {
    color: ${TEXT_GREY_DARK} !important;
    display: flex !important;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    height: 34px;
  }
`

export const _InputWithLabel = styled(InputWithLabel)`
  span {
    color: ${TEXT_GREY};
  }

  .tooltipTrigger {
    height: 14px;
    width: 14px;
    font-size: 10px;
    margin-left: 4px;
  }
  input {
    text-align: start;
  }
  ${({ withDollar }) =>
    withDollar &&
    `
    input {
      padding-left: 24px !important;
      padding-right: 15px;
    }
    label + div {
      &:before {
        content: '$';
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
        color: ${TEXT_GREY};
      }
  }
  `};
  ${({ withPercent }) =>
    withPercent &&
    `
   input {
      padding-left: 1.5rem;
      padding-right: 15px;
    }
    label + div {
      &:after  {
        content: '%';
        position: absolute;
        top: 35%;
        left: 50px;
        color: ${TEXT_GREY};
      }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  `};
  label {
    color: ${TEXT_GREY_DARK} !important;
    display: flex !important;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    height: 34px;
    .tooltipContainer {
      margin-left: 4px;
    }
  }
  ${({ withText }) =>
    withText &&
    `
     label + div {
       &:after  {
        content: '${withText}';
        position: absolute;
        top: 35%;
        right: 16px;
        color: ${TEXT_GREY};

      }
    }
    `};
  label {
    font-size: 12px;
  }
  ${({ smallInputField }) =>
    smallInputField &&
    `
      input {
        width: 110px !important;
      }
      @media screen and (max-width: ${BREAK_POINT_LG}) {
        input {
          width: 100%  !important;
        }
  }
    `};
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    .formInput {
      margin-bottom: 12px;
    }
  }
`

const fadeIn = keyframes`
  0% {
    display: block;
    opacity: 0;
  }
    50% {
      opacity: 1;
  }
  100% {
    display: none;
    opacity: 0;
  }
`

export const _ErrorMsg = styled.span`
  color: ${PRIMARY_NORMAL_COLOR};
  position: absolute;
  bottom: -1.5rem;
  white-space: nowrap;
  animation-name: ${fadeIn};
  animation-duration: 4s;
  animation-fill-mode: forwards;
`

export const infoTipIconContainerCss = css`
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 10;
  svg {
    fill: ${GREY_LIGHTER_COLOR};
    pointer-events: visible;
  }
  &:hover {
    cursor: pointer;
  }
`

export const interestRateTipContainerCss = css`
  position: absolute;
  top: 0.5rem;
  right: 0.25rem;
  svg {
    fill: ${GREY_LIGHTER_COLOR};
  }
  &:hover {
    cursor: pointer;
  }
`

export const resultInfoTipContainerCss = css`
  position: absolute;
  bottom: 0.5rem;
  right: 0.25rem;
  svg {
    fill: ${GREY_LIGHTER_COLOR};
  }
  &:hover {
    cursor: pointer;
  }
`

export const _Calculator = styled.form`
  width: 100%;
  max-width: 470px;
  label {
    display: block;
    padding: 0.5rem 0;
    white-space: nowrap;
    font-weight: 500;
    font-size: 12px;
    color: ${GREY_DARK_COLOR};
    margin-bottom: 6px;
    font-family: Montserrat;
  }

  input {
    width: 100%;
    height: 50px;
    padding: 15px;
    border: 1px solid ${OUTLINE_COLOR};
    font-size: 14px;
    border-radius: 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: ${TEXT_GREY};
  }

  select {
    display: block;
    width: 100%;
    padding: 0 0 0 8px;
    height: 50px;
    font-size: 15px;
    border: none;
    border-radius: 0;
    background-color: ${GREY_LIGHTER_COLOR};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: grey;
  }
  h4 {
    display: block;
    margin-bottom: 0;
    padding-right: 1rem;
  }
  position: relative;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    max-width: 100%;
  }
`

export const _EachPaymentResult = styled.div`
  padding: 0.5rem 0;
  font-size: 22px;
  font-weight: 500;
  color: ${PRIMARY_SECONDARY_COLOR} !important;
`

export const _Disclaimer = styled.div`
  color: rgba(112, 112, 112, 1);
  font-size: 10px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`

export const _LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    text-align: left;
    margin-right: 14px;
  }
  img {
    width: 99px;
  }
  position: absolute;
  right: 0;
  bottom: 0;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`

export const _RateImageContainer = styled.div`
  width: 79px;
  img {
    height: auto;
    width: 100%;
  }
  position: absolute;
  bottom: 30%;
  right: 12px;
`

export const _ResetBtn = styled.div`
  color: ${PRIMARY_SECONDARY_COLOR};
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  position: absolute;
  top: 45%;
  right: 24px;
  :hover {
    cursor: pointer;
  }
`

export const _LogoContainerMobile = styled.div`
  display: none;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: flex;
    justify-content: center;
    align-items: end;
    margin: 32px 0;
    span {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      text-align: left;
      margin-right: 14px;
    }
    img {
      width: 99px;
    }
  }
`

export const _GetApprovedCTA = styled.a`
  height: 44px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  background-color: ${CLICKABLE_COLOR};
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  :hover {
    cursor: pointer;
  }
  @media screen and (min-width: ${BREAK_POINT_LG}) {
    @media (hover: hover) {
      :hover {
        background: ${BUTTON_HOVER};
      }
    }
  }
  :active {
    background: ${SELECTED_ITEM_BG_COLOR};
  }
`
